export const UniiqueFeaturesList = [
    {
        id:1,
        title:"Unique Features",
        folderTitle:"/images/unique/",
        images:["1.jpg","2.jpg","3.jpg","4.jpg","12.jpg","5.jpg","7.jpg","9.jpg","10.jpg","11.jpg","8.jpg"]
    },
     

]